<template lang="pug">
  v-text-field(
    v-bind="$attrs"
    v-model="_value"
    @keydown="handleKeydown"
    @blur="$emit('blur', $event)"
    ref="input"
    )
</template>

<script>
import { numberFormatter } from './services/numberUtils'
import integerInputHandler from './services/integerInputHandler'
export default {
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    noFormat: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: [Number, null],
      default: null,
    },
  },
  computed: {
    _value: {
      get() {
        if (this.noFormat) return this.value
        let val = numberFormatter(this.value)
        return val
      },
      set(val) {
        if (this.noFormat) this.$emit(val)
        this.$emit('input', val.split('.').join(''))
      },
    },
  },
  methods: {
    handleKeydown(e) {
      this.$emit('keydown', e)
      integerInputHandler(e, this._value, this.maxLength)
    },
    focus() {
      this.$nextTick(() => this.$refs.input.focus())
    },
  },
}
</script>
